'use strict';

function _BranchIO() {
  this.node = null;
  this.id = null;
  this.declaredClass = null;
  this.extends = [];
  this.analytics = new Analytics();
  this._key = 'key_test_bkoXeAOc9FLfnxKMUy20AncozudH77Hd'; // TEST/QA/DEV
  this._keyProd = 'key_live_gmmYmxKg3FJlnzRIICY3qpdjrAcK92A4'; // Production

  this.hasApp = null;

  this.init = function () {
    this.branchIOInit();
  };

  this.initAllReady = function () {};

  this.destroy = function () {};

  this.branchIOInit = function () {
    if (location.hostname === 'www.mogo.ca') {
      this._key = this._keyProd;
    }

    var options = {
      no_journeys: !!(mogo.params && mogo.params.webview === true),
      disable_entry_animation: true,
      disable_exit_animation: true
    };

    branch.init(this._key, options, function (err, data) {
      if (err) {
        console.error('branchIOInit:', err);
      }
      if (data.has_app) {
        this.hasApp = true;
      }
    });

    branch.addListener('didShowJourney', this.viewJourneyAnalytics);
    branch.addListener('didClickJourneyClose', this.closeJourneyAnalytics);
    branch.addListener('didClickJourneyCTA', this.clickJourneyAnalytics.bind(this));
  };

  this.viewJourneyAnalytics = function (event, data) {
    dataLayer.push({
      event: 'DLevent.branchBanner',
      branchBannerAction: 'Shown ' + data.journey_link_data.journey_name,
      branchBannerVariation: data.journey_link_data.view_name,
      branchBannerURL: data.journey_link_data.data.$canonical_url
    });
  };

  this.closeJourneyAnalytics = function (event, data) {
    dataLayer.push({
      event: 'DLevent.branchBanner',
      branchBannerAction: 'Close ' + data.journey_link_data.journey_name,
      branchBannerVariation: data.journey_link_data.view_name
    });
  };

  this.clickJourneyAnalytics = function (event, data) {
    dataLayer.push({
      event: 'DLevent.branchBanner',
      branchBannerAction: this.hasApp ? 'OPEN ' : 'GET ' + data.journey_link_data.journey_name,
      branchBannerVariation: data.journey_link_data.view_name
    });
  };

  this.branchSetIdentity = function (callback) {
    var _uuId = this.presenter.getModelProperty('account.uuid');
    if (_uuId) {
      if (callback) {
        branch.setIdentity(_uuId, callback);
      } else {
        branch.setIdentity(_uuId);
      }
    } else {
      this.analytics.forcePushEvent('generic-push-event', {
        event: ['branchSetIdentityError']
      });
    }
  };
}